import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const WORDS = ['hello', 'salut', 'こんにちは', '안녕', 'hola', 'ciao'];

export default function LoadingScreen({ onComplete }) {
  const [index, setIndex]   = useState(0);
  const [exiting, setExiting] = useState(false);

  const finish = useCallback(() => {
    setExiting(true);
    setTimeout(onComplete, 350);
  }, [onComplete]);

  useEffect(() => {
    if (index < WORDS.length - 1) {
      const t = setTimeout(() => setIndex(i => i + 1), 200);
      return () => clearTimeout(t);
    } else {
      const t = setTimeout(finish, 250);
      return () => clearTimeout(t);
    }
  }, [index, finish]);

  return (
    <AnimatePresence>
      {!exiting && (
        <motion.div
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: '#05050a',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          {/* Glow centrale */}
          <div style={{
            position: 'absolute',
            width: 400, height: 400,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(124,58,237,0.12) 0%, transparent 70%)',
            pointerEvents: 'none',
          }} />

          <AnimatePresence mode="wait">
            <motion.span
              key={index}
              initial={{ opacity: 0, y: 24, filter: 'blur(6px)' }}
              animate={{ opacity: 1, y: 0,  filter: 'blur(0px)' }}
              exit={{    opacity: 0, y: -24, filter: 'blur(6px)' }}
              transition={{ duration: 0.14, ease: [0.16, 1, 0.3, 1] }}
              style={{
                fontFamily: 'var(--font-display)',
                fontSize: 'clamp(3rem, 9vw, 6rem)',
                color: 'white',
                fontWeight: 200,
                letterSpacing: '0.15em',
                position: 'relative', zIndex: 1,
              }}
            >
              {WORDS[index]}
            </motion.span>
          </AnimatePresence>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
